export default __webpack_public_path__ + "static/media/white-logo.c970aeb6.svg";